module.exports = __webpack_public_path__ + "static/media/Miraji death news.dd4a2aa1.jpg";